function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M35 32h8.224A12.777 12.777 0 0 0 56 19.224v-.002c0-.855-.339-1.674-.944-2.278A3.217 3.217 0 0 0 52.778 16H11.222c-.855 0-1.674.339-2.278.944A3.217 3.217 0 0 0 8 19.222v.002A12.777 12.777 0 0 0 20.776 32H29",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 25v21.915A4.085 4.085 0 0 0 13.085 51h37.83A4.085 4.085 0 0 0 55 46.915V25M44 16v-4.021A1.979 1.979 0 0 0 42.021 10H21.979A1.979 1.979 0 0 0 20 11.979V16",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 31c0-.796-.316-1.559-.879-2.121A2.996 2.996 0 0 0 32 28h-.002A2.999 2.999 0 0 0 29 30.998V34c0 .796.316 1.559.879 2.121a2.996 2.996 0 0 0 4.242 0A2.996 2.996 0 0 0 35 34v-3zM18 47h-2.596A2.403 2.403 0 0 1 13 44.596V42",
    style: {
      fill: "none",
      strokeWidth: 3
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/companyIcon.482254ed.svg";
export { ForwardRef as ReactComponent };